import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'markdown-ui', {
    toolbarHeadingOne: 'Heading one ⌘⌥+1',
    toolbarHeadingTwo: 'Heading two ⌘⌥+2',
    toolbarHeadingThree: 'Heading three ⌘⌥+3',
    toolbarHeadingFour: 'Heading four ⌘⌥+4',
    toolbarBlockQuote: 'Block quote ⌘⌥+Q',
    toolbarCodeBlock: 'Code block',
    toolbarBold: 'Bold ⌘+B',
    toolbarItalic: 'Italic ⌘+I',
    toolbarInlineCode: 'Inline code ⌘+K',
    toolbarStrikethrough: 'Strikethrough',
    toolbarBlockQuoteShort: 'Quote',
    toolbarBulletedList: 'Bulleted list',
    toolbarNumberedList: 'Numbered list',
    toolbarDecreaseIndent: 'Decrease indent',
    toolbarIncreaseIndent: 'Increase indent',
    toolbarInsertVerticalBreak: 'Insert vertical break',
    toolbarInsertVariable: 'Insert variable',
    toolbarInsertImage: 'Insert image',
    toolbarViewRichText: 'View rich text',
    toolbarViewMarkdown: 'View markdown',
    toolbarComment: 'Comment',
    toolbarPreviousComment: 'Previous comment',
    toolbarNextComment: 'Next comment',
    feedbackWrapTitle: '',
    feedbackWrapPrompt:
      'No more comments in the document. Would you like to jump to the first comment? (Yes/No)',
    feedbackWrapYes: 'Yes',
    feedbackWrapNo: 'No',
    promptMenuCommands: 'Commands',
    promptMenuDepartments: 'Departments',
    promptMenuFunctions: 'Functions',
    promptMenuAutomations: 'Automations',
    promptMenuProjects: 'Projects',
    promptMenuNoMatches: 'No matches',
    promptMenuLoading: 'Loading…',
    editorDemoPlaceholder: 'Enter a system prompt and apply markdown formatting if desired...',
  });
}
